import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_DISMISS_ERROR,
} from './constants';
export function createCollectionWithPrompt(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/createWithPrompt`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionTitle,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to create collection');
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_FAILURE,
            data: { error: errMsg },
          });
          console.log('createWithPrompt error', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithPromptError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_BEGIN:
      return {
        ...state,
        createCollectionWithPromptPending: true,
        createCollectionWithPromptError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_SUCCESS:
      return {
        ...state,
        createCollectionWithPromptPending: false,
        createCollectionWithPromptError: null,
        projectCollections: [...state.projectCollections, action.data],
        selectedCollection: action.data,
        promptItems: [],
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_FAILURE:
      return {
        ...state,
        createCollectionWithPromptPending: false,
        createCollectionWithPromptError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_WITH_PROMPT_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithPromptError: null,
      };

    default:
      return state;
  }
}
